module.exports = __webpack_public_path__ + "img/public/AdminIcons/manageReservation.svg?4528a974";